module.exports = __webpack_public_path__ + "img/3_b.2eac67fc.jpg";